import { Result } from "@bidbattles/bloks/lib/result";
import type { LabelledRowVariant } from "@bidbattles/bloks/lib/ui";

// biome-ignore lint/complexity/noBannedTypes: may not be empty in the not so distant future
export type Flags = {};

export const VITE_ENVIRONMENTS = [
	"development",
	"staging",
	"production",
] as const;
export type ViteEnvironment = (typeof VITE_ENVIRONMENTS)[number];

export interface FormConfig {
	labelledRowVariant?: LabelledRowVariant;
}

export interface Config {
	env: ViteEnvironment;
	flags: Flags;
	form: FormConfig;
	isServer: boolean;
	apiURL: Result<string>;
	rtURL: Result<string>;
	rtHttpURL: Result<string>;
	logout: () => Promise<Result<null>>;
	getLocale: () => Intl.UnicodeBCP47LocaleIdentifier;
	getCookie__ServerOnly: () => string | null;
}

const missing = () => new Error("missing call to `configure`");
const config: Config = {
	env: "production",
	flags: {},
	form: {},
	isServer: typeof window === "undefined",
	apiURL: Result.error(missing()),
	rtURL: Result.error(missing()),
	rtHttpURL: Result.error(missing()),
	logout: () => {
		throw missing();
	},
	getLocale: () => "en",
	getCookie__ServerOnly: () => {
		throw missing();
	},
};
type RequiredConfig = Pick<
	Config,
	"env" | "logout" | "apiURL" | "rtURL" | "rtHttpURL" | "getCookie__ServerOnly"
>;
export type PartialConfigWithRequiredFields = Omit<
	Partial<Config>,
	keyof RequiredConfig
> &
	RequiredConfig;

export function getConfig(): Readonly<Config> {
	return config;
}
export function configure(partialConfig: PartialConfigWithRequiredFields) {
	Object.assign(config, partialConfig);
}
